import { IPanelProps } from 'office-ui-fabric-react'
import { useCallback, useState } from 'react'

export type PanelState = Partial<IPanelProps>

export function usePanelState(initialState: PanelState = {}) {
  const [panelState, setPanelState] = useState<PanelState>({
    ...initialState,
  })
  const showPanel = useCallback(
    () => setPanelState((state) => ({ ...state, isOpen: true })),
    [setPanelState]
  )
  const hidePanel = useCallback(
    () => setPanelState({ isOpen: false }),
    [setPanelState]
  )

  return [
    { ...panelState, onDismiss: initialState.onDismiss || hidePanel },
    showPanel,
    hidePanel,
  ] as [PanelState, typeof showPanel, typeof hidePanel]
}
